export default class Accordion {
  constructor(contents) {
    this.contents = contents;
    if (!this.contents) {
      return;
    }
    this.opener = this.contents.querySelector("._opener");

    this.setup();
  }

  setup() {
    this.opener.addEventListener("click", (event) => {
      if (this.contents.classList.contains("open") === true) {
        this.contents.classList.remove("open");
        this.opener.setAttribute('aria-expanded', 'false');
      } else {
        this.contents.classList.add("open");
        this.opener.setAttribute('aria-expanded', 'true');
      }
    });
  }
}
